import type { FaireProductEntity } from "../../entity_types/product";

export const p_d4y9ra8r6s: FaireProductEntity = {
  token: "p_d4y9ra8r6s",
  type: "product",
  name: "Autumn Berry Pitcher Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/91ae4cc02cb1a689ab3376da04b86ad6b739f4aeb8f838ac4949fae581ecec68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1958391d2ea9c745244f83ce26d51b9b61aff0cc596e3c86caf833e3ecf92995.jpeg",
    "https://cdn.faire.com/fastly/463758af181db6572d12a2441fcc8a228040590748dab1bf5c0c282841cd2edc.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:23.769Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
